import { render, staticRenderFns } from "./import-summary.vue?vue&type=template&id=05bd0289"
import script from "./import-summary.vue?vue&type=script&lang=js"
export * from "./import-summary.vue?vue&type=script&lang=js"
import style0 from "./import-summary.vue?vue&type=style&index=0&id=05bd0289&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports